import React, {useEffect, useState} from "react";
import {Button, Checkbox, Col, Form, Input, Modal, Popconfirm, Row, Select, Spin, Table, Typography} from "antd";
import SelectField from "components/SelectField";
import './GppTransfer.scss'
import {useTranslation} from "react-i18next";
import {SelectOptions} from "../../../../../services/form";
import {Account, getAccounts} from "../../../../../services/account";
import {getCurrentCompany} from "../../../../../services/user";
import {financial} from "../../../../../services/helper";
import InputField from "components/InputField";
import GppModal from "pages/Transfer/components/GPP/component/GppModal";
import {
    calculateCommision,
    gppCheck,
    gppclassificationCode,
    moneyTransferGpp, partialPayment
} from "../../../../../services/Transfers/GppTransfer";
import {
    ArrowDownIco,
    ArrowUpIco,
    ClearIco, EditIco, EditIcon,
    InnerReloadIco, ModalCloseIco,
    RemoveIco, SpinnerIco, TabsInfoIco
} from "../../../../../../modules/CustomIcons";
import {BUTTONS, OWNACCOUNT} from "constants/constants";
import InnerTable from "pages/MassTransfers/InnerTable";
import ClassificationModal from "pages/Transfer/components/GPP/component/ClassificationModal";
import TableComponent from "components/Table";
import NextModalGpp from "pages/Transfer/components/GPP/component/nextModal/NextModalGpp";
import EditableCell from "components/Table/EditableCell";
import MoreModal from "pages/Transfer/components/GPP/component/MoreModal";
import FullScreenLoading from "components/FullScreenLoading";
import moreModal from "pages/Transfer/components/GPP/component/MoreModal";
import CustomTooltip from "components/Tooltip";
import {getGppDocumentNumber, getIpsNonBdgDocumentNumber} from "../../../../../services/Accounts/DocumentNumber";
import moment from "moment";
import {CheckBox} from "@mui/icons-material";
import TimerCell from "pages/Transfer/components/GPP/component/nextModal/TimerCell";
const { Text } = Typography;
const { Option } = Select;
const data: any = [
    {
        key: '1',
        name: 'John Brown',
        money: '￥300,000.00',
        address: 'New York No. 1 Lake Park',
    },
    {
        key: '2',
        name: 'Jim Green',
        money: '￥1,256,000.00',
        address: 'London No. 1 Lake Park',
    },
    {
        key: '3',
        name: 'Joe Black',
        money: '￥120,000.00',
        address: 'Sydney No. 1 Lake Park',
    },
];

const GppTransfer: React.FC<any> = (props) => {
    const {t} = useTranslation()
    const [form] = Form.useForm()
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [allAccounts, setAllAccounts]=useState([]);
    const [isActive,setIsActive]= useState(true)
    const [fromBranch, setFromBranch] = useState<Account>(null)
    const [accountValue, setAccount] = useState(null)
    const [visible,setVisible] = useState(false)
    const [transferData,setTransferData] = useState([])
    const [tableVisible,setTableVisible] = useState(false)
    const [tableHeader,setTableHeader] = useState('')
    const [tableData,setTableData] = useState([])
    const [fields,setFields] = useState( props.fields)
    const [value,setValue] = useState()
    const language = localStorage.getItem("i18nextLng")
    const [allCleanModal,setAllCleanModal] = useState(false)
    const [modalVisible,setModalvisible] = useState(false)
    const [key,setKey] = useState('')
    const [classificationData,setClassificationData] = useState([])
    const [classificationModal,setClassificationModal] = useState(false)
    const [selectedType,setSelectedType] = useState(null)
    const [additional,setAdditional] = useState('')
    const [formData,setFormData] = useState()
    const [selectedField,setSelectedField] = useState()
    const [placeholder1,setPlaceHolder1]= useState('')
    const [placeholder2,setPlaceHolder2]= useState('')
    const [nextModalvisible, setNextModalVisible] = useState(false)
    const [prefix,setPrefix] = useState('')
    const [errorMessage,setErrorMessage] = useState('')
    const [messageVisible,setMessageVisible] = useState(false)
    const [paymentReceiver,setPaymentReceiver] = useState('')
    const [phone,setPhone] = useState(false)
    const [moreVisible,setMoreModal] = useState(false)
    const [feeCalculationMethod,setfeeCalculationMethod] = useState('')
    const [loading,setLoading] = useState(false)
    const [noHover, setHover] = useState(false)
    const [deleteVendorKey,setDeleteVendorKey] = useState('')
    const [moreData,setMoreData] = useState()
    const [documentNo,setDocumentNo] = useState('')
    const [isEditable,setIsEditable] = useState(false)
    const [servicecode,setServicecode] = useState('')
    const [serviceDesc,setServiceDesc] = useState('')
    const [invoiceId,setInvoiceId] = useState('')
    const [classTitle,setClassTitle] = useState('')
    const [maxAllowedAmount,setMaxAllowedAmount] = useState(null)
    const [category,setcategory]= useState('')
    const [clearRow,setClear] = useState(false)
    const [single_alert,setSingleAlert] = useState('none')
    const [activeExpRow, setActiveExpRow] = useState<Array<any>>([]);
    const [accountKey, setAccountKey] = useState("");
    const [checkData,setcheckData] = useState()
    const [isRotated, setIsRotated] = useState(false);
    const [searchLoad,setSearchLoad] = useState(false)
    const [selectedValue, setSelectedValue] = useState([]);
    const [dataFiltered,setDataFiltered] = useState([])
    const [childinvoice,setChildinvoice] = useState(false)
    const [isChecked,setIsChecked] = useState(false)
    const [timerMessage,setTimerMessage] = useState(false)

    const handleChange = () => {
        setIsRotated(!isRotated);
    };

    const onClearRow = (record) =>{
        setModalvisible(true);
        setKey(record.key)
        setDeleteVendorKey(record.paymentTypeCode)
    }

    const checkBoxChange=(e,row)=>{
        e.stopPropagation()
        let temp_data = tableData;
        // var updatedList:any = [...checkedValue];


        if (e.target.checked) {
            const newData = tableData.find((item) => item.paymentTypeCode === row.vendorId);
            if (newData !== null && newData != undefined) {
                if(newData?.paymentRow[0].invoiceType === 'SIMPLE' || newData?.paymentRow[0].invoiceType === 'AVANS') {
                    const oldPaymentRow = newData?.paymentRow.find((item1) => item1.transactionId === row.transactionId && item1.selected && item1.id !== row.id);
                    const index = tableData.findIndex((item) => item.paymentTypeCode === row.vendorId);
                    // delete oldPaymentRow from updatedList
                    if(oldPaymentRow !== null && oldPaymentRow !== undefined) {
                        const oldPaymentRowIndex = newData?.paymentRow.findIndex((item1) => item1.id === oldPaymentRow.id);
                        if (oldPaymentRowIndex !== -1) {
                            temp_data[index].paymentRow[oldPaymentRowIndex].selected = false
                        }
                    }
                    // add newPaymentRowIndex to updatedList
                    const newPaymentRowIndex = newData?.paymentRow.findIndex((item1) => item1.id === row.id);
                    if (newPaymentRowIndex !== -1) {
                        temp_data[index].paymentRow[newPaymentRowIndex].selected = true
                    }
                }
            }
        }
         else {
            const index = tableData.findIndex((item) => item.paymentTypeCode === row.vendorId);
            if (index !== -1) {
                const newPaymentRowIndex = tableData[index].paymentRow.findIndex((item1) => item1.id === row.id);
                if (newPaymentRowIndex !== -1) {
                    temp_data[index].paymentRow[newPaymentRowIndex].selected = false
                }
            }


        }


        setTableData(temp_data)
        setIsChecked(!isChecked)


    }

    useEffect(()=>{
        let dataFiltered1
        let selectedTemp
        tableData.map((row:any)=>{

            dataFiltered1 = row.paymentRow.filter((line)=> ((line.invoiceType==='SIMPLE' || line.invoiceType==='AVANS' ) && !line.selected))

            selectedTemp = row.paymentRow.filter((line)=>((line.invoiceType==='SIMPLE' || line.invoiceType==='AVANS' ) && line.selected) )
            if(dataFiltered1.length>0){
                setDataFiltered(dataFiltered1)
            }
            if(selectedTemp.length>0){
                setSelectedValue(selectedTemp)
                const timeNull = row.paymentRow.filter((line)=> line.selected && line.time === 0)
                if(timeNull.length > 0) {
                    setDataFiltered(timeNull);
                } else {
                    setDataFiltered([])
                }
            }


        })

    },[tableData,isChecked])

    const endTime = (row,time) => {

        let temp_data = tableData;
        const index = tableData.findIndex((item) => item.paymentTypeCode === row.vendorId);
        if (index !== -1) {
            const oldPaymentRowIndex = tableData[index].paymentRow.findIndex((item1) => item1.id === row.id);
            if (oldPaymentRowIndex !== -1) {
                setSelectedValue([])
                if(time === 0) {
                    temp_data[index].paymentRow[oldPaymentRowIndex].selected = false



                }
                temp_data[index].paymentRow[oldPaymentRowIndex].time = time;
            }
        }

        setTableData(temp_data)
        if(time===0){

            setIsChecked(!isChecked)
        }

    }

    const columns: any = [
        // {
        //     title: "",
        //     dataIndex: 'name',
        //     render: (text,record) => <TimerCell endTime={(time) => { endTime(record,time)} } time={record.time}/>,
        //     align: 'start',
        // },
        // {
        //     dataIndex: 'id',
        //     render:(text,record)=>
        //         tableData.length >= 1 && record.time !== 0&& (record.invoiceType==='SIMPLE' || record.invoiceType==='AVANS' ) ? (
        //
        //            <Checkbox
        //               className={!isChecked ?'innerNonChecked':''}
        //                onChange={(e)=>checkBoxChange(e,record)}
        //                // checked={checkedValue.id===text}
        //                 checked={record.selected}
        //                defaultChecked={tableData.paymentRow?.length===1}
        //            />
        //
        //         ) : null
        //
        // },
        {
            title: t('businessCards.user'),
            dataIndex: 'name',
            width:300,
            render: (text) => {
             return <p style={{whiteSpace: "break-spaces"}}>{text}</p>
            },
            align: 'start',
        },
        {
            title: t("transfers.idCode"),
            className: 'idCode',
            dataIndex: 'idCode',
            align: 'start',
            render:(text:any) =>{

                return <div className={'flex'}>
                    {
                        text?.length>12?
                            <CustomTooltip  title={text}>
                             {text}
                    </CustomTooltip> :
                            <p>{text}</p>
                    }
                    {/*{any}*/}

                </div>
            }

        },
        {
            title: t('transfers.docNumber'),
            dataIndex: 'PMTID',
            align: 'start',
            render:(text)=>{
                if(text === null){
                    return '-'
                }else{
                    return <CustomTooltip  title={text}>
                        {text}
                    </CustomTooltip>
                }
            }

        },
        {
            title:t("transfers.docDate"),
            dataIndex: 'date',
            align: 'start',
            render:(text)=>{
                if(text === null){
                    return '-'
                }else{
                    return text
                }
            }
        },
        {
            title:t("transfers.serviceType"),
            dataIndex: 'serviceCode',
            align: 'start',
            render:(text,record) =>{

                return <div className={'flex'}>
                    {text}
                    <CustomTooltip  title={record.serviceDesc}>
                        <Button
                            type={'ghost'}
                            className={'transparent'}
                            style={{ margin: 'auto' }}
                            icon={<TabsInfoIco />}
                        />
                    </CustomTooltip>
                </div>
            }
        },
        {
            title: t("common.amount")+' (AZN)',
            dataIndex: 'amount',
            align: 'end',
            key: 'amount',
            editable: isEditable,
            ellipsis: true,
            render: (text: string, record: any, index: string) => {

                let amountData
                let decimalPart = text && text.toString().split('.')[1]
                if (text !== '' && text !== undefined && text !== ' ') {
                    amountData =
                        !record.child ?
                        (!isNaN(text) &&
                        text !== '' &&
                        ((decimalPart && decimalPart.length < 3) || !decimalPart) ? (

                            <div style={{textAlign:"center"}} className="flex  editable-cell-value-wrap__added  editableCreateTransfer-form-item__added">
                                {financial(text) !=='0.00' ? <p style={{marginRight:6}} className="border editable-form-item__input editable-form-item__input--bordered">
                                    {financial(text)}
                                </p> : <p style={{marginRight:6,color:"red"}} className="border editable-form-item__input editable-form-item__input--bordered">
                                    {financial(text)}
                                </p> }

                                <EditIco />
                            </div>

                        ) : (
                            <div
                                style={{ maxWidth: 80,textAlign:"center" }}
                                className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary"
                            >
                                <p style={{color:"red"}}>{text !== '' ? financial(text) : '0.00'}</p>
                            </div>
                        )) :(
                                <p style={{marginRight:6}} className="border editable-form-item__input editable-form-item__input--bordered">
                                    {financial(text)}
                                </p>
                            )
                    return amountData
                } else {
                    return (
                        <div style={{textAlign:"center"}}  className="flex editable-cell-value-wrap__added border editableCreateTransfer-form-item__added">
                            <p style={{color:"red"}} className="editable-form-item__input editable-form-item__input--bordered">
                                {financial("0.00")}
                            </p>
                            <EditIco />
                        </div>
                    )
                }
            },

        },
        {
            title:t("home.commission")+' (AZN)',
            dataIndex: 'COMMAMOUNT',
            align: 'start',
            render:(text)=>{

                return <p style={{textAlign:'center'}}>{!isActive ?  <Spin  indicator={<SpinnerIco />}/> :financial(text)}</p>
            }
        },
        {
            title: '',
            dataIndex: '10',
            align:"center",
            width:84,
            render:(a, record: { key: any}) =>
                // console.log(a)
                // console.log(record)
                tableData.length >= 1 && (record?.allowedPayableAmount || record.invoiceType!=='GROUP') ? (
                    <Button style={{border: "none", boxShadow: "none"}} onClick={() => {
                        onClearRow(record)
                    }}>
                        <a><ClearIco/></a>
                    </Button>

                ) : null
            ,
        }

    ];

    const fetchData = async () => {

        const data = await getAccounts(getCurrentCompany());
        let temp_data=[];
        const new_data = data.filter(row=>row.CCY_NAME == "AZN")

        let field_data = []
        props.fields?.map((row)=>{
            field_data.push({
                label:row.title,
                fieldId:row.fieldId,
                subType:row.subType,
                validationRegex:row.validationRegex,
                name:row.name,
                type:row.type,
                options:row.options,
                inputType:row.inputType,
                value:row.subType,
                prefixLists: row.prefixLists
            })
        })
        setcategory(props.category)

        for (let row of new_data ){
             if( row.STATUS !== "0" &&
            row.PRODUCT_CODE !== "140110" &&
            row.PRODUCT_CODE !== "140111")
            // @ts-ignore
             {
                 temp_data.push({
                     label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                     value: row.ACCOUNT_NO,
                     extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                 });
             }
        }

        setAllAccounts(new_data);
        setFields(field_data)
        setAllAccounts(data);
        setFromSelectOptions(old_data => temp_data);

        /**/

    };

    const selectPrefix =(e)=>{
       setPrefix(e)
    }

    const selectBefore = (
        <SelectField
            options={fields[0].prefixLists}
            value={prefix}
            name={'prefix'}

            transferType={true}
            onChange={selectPrefix}>
        </SelectField>
    );

    const pullData = (key,data,category) =>{
        setcategory(category)
        let temp_array=[]

        temp_array.push({
           data:data
        })
        setFields(data?.fields)
        setTransferData(temp_array)
        setVisible(false)
        pulldata2(data?.fields)
    }

    const pulldata2 = (field)=>{

        const selected = field[0]
        const bool = selected?.label?.includes('Telefon') || selected?.title?.includes('Telefon')
        setPhone(bool)
        setPrefix(bool ? fields[0].prefixLists[0]?.value :'')
        setSelectedType(selected.subType)
        setSelectedField(selected)
        if(selected.options?.length>0){
            setPlaceHolder1(selected?.options[0].title)
            setPlaceHolder2(selected?.options[1].title)
        }else{
            setPlaceHolder1(selected?.title)
        }
        form.setFieldsValue({
            'paymentType':selected.title
        })
    }

    const getSelectedFromBranch =async (value:any) => {

        const findAccount=allAccounts?.find(row => row.ACCOUNT_NO==value);

        setFromBranch(findAccount);
        if(findAccount !== undefined && findAccount !== null){
            const document_number = await  getGppDocumentNumber(getCurrentCompany());
            setDocumentNo(old_value => document_number)
        }
        setAccount(findAccount?.IBAN)

    }

    const getPaymentReceiver =(value:any,record:any,row)=>{
        setSingleAlert('')
        let temp_data = tableData;


        const newData = tableData.find((item) => item.paymentTypeCode === row.paymentTypeCode);

        if (newData !== null && newData != undefined) {
            const newPaymentRow = newData?.paymentRow.filter((item1) => item1.key === row.key)

            const indexNew = newData?.paymentRow.findIndex((item) => item.key === row.key)


            const index = tableData.findIndex((item) => item.paymentTypeCode === row.paymentTypeCode);
            if (newPaymentRow?.length > 0) {
               const paymentcode = record.filter((item)=>item.value=== value)

                temp_data[index].paymentRow[indexNew].manualPaymentReceiverCode = paymentcode[0].value
                temp_data[index].paymentRow[indexNew].paymentReceiverDescription = paymentcode[0].label
           

            } else {
                temp_data = tableData.filter((item) => item.paymentTypeCode === row.paymentTypeCode);
            }


        }
        setTableData(temp_data)
    }

    const getSelectedType = (value)=>{
       form.setFieldsValue({'VALUE':'','VALUE2':''})
        setAdditional('')
        const findType =fields?.find(row => row.subType === value)


        if(findType === undefined){
            const newtype = fields[Number(value)]

            const bool = newtype?.label?.includes('Telefon') || newtype?.title?.includes('Telefon')
            setPhone(bool)
            setSelectedType(newtype.subType)
            setSelectedField(newtype)
            if(newtype.options?.length>0){
                setPlaceHolder1(newtype.options[0].title)
                setPlaceHolder2(newtype.options[1].title)
            }else{
                setPlaceHolder1(newtype?.title || newtype?.label )
            }
        }else{
            const bool = findType?.label?.includes('Telefon') || findType?.title?.includes('Telefon')
            setPhone(bool)

            setSelectedType(findType.subType)
            setSelectedField(findType);
            if(findType.options?.length>0){
                setPlaceHolder1(findType.options[0].title)
                setPlaceHolder2(findType.options[1].title)
            }else{
                setPlaceHolder1(findType?.title || findType?.label)
            }
        }
    }

    const onMore = (record) =>{
        setMoreData(record)
        setMoreModal(true)
    }

    useEffect(() => {

        fetchData();
        const selected = fields[0]
        const bool = selected?.label?.includes('Telefon') || selected?.title?.includes('Telefon')
        setPhone(bool)

        setPrefix(fields[0].prefixLists[0]?.value !== undefined ? fields[0].prefixLists[0]?.value :'')
        setSelectedType(selected.subType)
        setSelectedField(selected)
        if(selected.options?.length>0){
            setPlaceHolder1(selected?.options[0].title)
            setPlaceHolder2(selected?.options[1].title)
        }else{
            setPlaceHolder1(selected?.title)
        }
        form.setFieldsValue({
            'paymentType':selected.title
        })

    }, []);

    const handleDelete = (key: React.Key, deleteVendorKey: any) => {

        let temp_data = tableData;

        const newData = tableData.find((item) => item.paymentTypeCode === deleteVendorKey);
        if(newData !== null && newData != undefined) {
            const newPaymentRow = newData?.paymentRow.filter((item1) => item1.key !== key)
            const index = tableData.findIndex((item) => item.paymentTypeCode === deleteVendorKey);
            if(newPaymentRow?.length > 0) {
                temp_data[index].paymentRow = newPaymentRow;
            } else {
                temp_data = tableData.filter((item) => item.paymentTypeCode !== deleteVendorKey);
            }
            setTableData(temp_data);
            setModalvisible(false)
            if(temp_data.length === 0 ){
                setTableVisible(false)
            }
        }
    };

    const onClearAll = (record) => {
        setDeleteVendorKey(record.paymentTypeCode)
        setAllCleanModal(true)
    }

    const handleDeleteAll = (deleteVendorKey) =>{

        let temp_data = tableData;
        const newData = tableData.find((item) => item.paymentTypeCode === deleteVendorKey);
        if(newData !== null && newData != undefined) {

            const cashData = tableData.filter((item) => item.paymentTypeCode !== deleteVendorKey);
            setTableData(cashData);
            // setModalvisible(false)
            if(cashData.length === 0 ){
                setTableVisible(false)
            }
        }

        // setTableVisible(false)
        setAllCleanModal(false)
    }

    const onSearch = async (data, code, type) =>{
        console.log(data)
        setTimerMessage(true)
        setSearchLoad(true)
        let keyTable = 0;
        setClassTitle(data.title)
        setErrorMessage('')
        // setLoading(true)
        if(data !== undefined || data !== null) {
            setFormData(data)
        }
        // setChildinvoice(false)
        const formData =
            {
                sourceId: "1",
                vendorId: data?.vendorId,
                code : prefix+value,
                identificationSubtype : selectedType,
                additionalCode:additional
            }
        let temp_data = []
        if(type === "main"){
            console.log("main");
            const checkedData = await gppCheck(formData,language)
            setcheckData(checkedData)
            if(checkedData.data?.invoiceList?.length>0 && checkedData.status?.description!== 'SERVICE_UNAVAILABLE' && checkedData.status?.code !== 400 && checkedData.data?.transactionId !==null){
                setClassificationModal(false);
                for(var row1 in checkedData.data?.invoiceList) {
                    var row = checkedData.data?.invoiceList[row1]
                    {
                        if(row?.childInvoiceList !== null && row?.childInvoiceList !== undefined && row?.childInvoiceList?.length >0){
                            setChildinvoice(true)
                            for(var line1 in row?.childInvoiceList)
                            {
                                var line = row?.childInvoiceList[line1]
                                // row.allowedPayableAmount  ? setIsEditable(true) :setIsEditable(false)
                                setfeeCalculationMethod(row.feeCalculationMethod)
                                setServiceDesc(row.serviceDescription)
                                setServicecode(row.serviceCode)
                                setInvoiceId(row.invoiceId)
                                const feeCalcList = checkedData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===line.feeCalculationMethod)
                                const req = {
                                    "feeCalculationMethod": line.feeCalculationMethod,
                                    'amount': line.amount,
                                    "feePercent":  feeCalcList[0].feePercent ,
                                    "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                                    "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                                }
                                let dataCom;
                                dataCom = await calculateCommision(req, language)
                                row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)

                                let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId && element.abonCode1 === prefix+value);
                                console.log(data?.vendorId)
                                console.log(temp_data)
                                if(seaarchVendorId === null || seaarchVendorId === undefined) {
                                    seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId && element.abonCode1 === prefix+value);
                                }
                                if(seaarchVendorId === null || seaarchVendorId === undefined) {
                                   console.log("null isledi")
                                    temp_data.push(...tableData,
                                        {
                                            paymentTitle: data.title,
                                            paymentTypeCode: data?.vendorId,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            abonCode1: prefix+value,
                                            child: true,
                                            paymentRow: [{
                                                feePercent:  feeCalcList[0].feePercent,
                                                feeMinAmount: feeCalcList[0].feeMinAmount,
                                                feeMaxAmount:feeCalcList[0].feeMaxAmount,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                key: line.id,
                                                id:row.id,
                                                selected:false,
                                                childInvoiceId:line.id,
                                                child:true,
                                                name: checkedData.data?.serviceAccount?.description,
                                                idCode:  line.invoiceCode,
                                                serviceCode: line.serviceCode,
                                                scCode:checkedData.data?.scCode,
                                                COMMAMOUNT:  dataCom?.data?.commission,
                                                amount: line.amount,
                                                PMTID: line.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:line.feeCalculationMethod,
                                                serviceDesc:line.serviceDescription,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkedData.data?.transactionId,
                                                manualPaymentReceiverCode:line.paymentReceiverCode,
                                                category:category,
                                                invoiceId:row.id ,
                                                paymentReceiverDescription:line.paymentReceiverDescription,
                                                time: 900,
                                            }],
                                            createRow:[{
                                                id:row.id,
                                                childInvoiceId:line.id,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                name: checkedData.data?.serviceAccount?.description,
                                                idCode: checkedData.data?.serviceAccount?.abonCode,
                                                codeService: row.serviceCode,
                                                scCode:checkedData.data?.scCode,
                                                commission: dataCom?.data.commission,
                                                pmtAmount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                serviceDescription:row.serviceDescription,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkedData.data?.transactionId,
                                                manualPmtReceiverCode:row.paymentReceiverCode,
                                                category:category,
                                                invoiceId:row.id,
                                                paymentReceiverDescription:row.paymentReceiverDescription,


                                            }],

                                        }
                                    )
                                }
                                else {
                                    let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId && element.abonCode1 === prefix+value);
                                    if(seaarchVendorIdIndex == -1) {
                                        seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId && element.abonCode1 === prefix+value);
                                    }
                                    const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === line.id && item1.idCode ===  line.invoiceCode)
                                    if(seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {
                                        keyTable = seaarchVendorId?.paymentRow?.length;
                                        temp_data = [...tableData]
                                        seaarchVendorId?.paymentRow?.push(
                                            {
                                                feePercent:  feeCalcList[0].feePercent , //
                                                feeMinAmount: feeCalcList[0].feeMinAmount  , //
                                                feeMaxAmount:feeCalcList[0].feeMaxAmount  , //
                                                invoiceType:row.invoiceType, //
                                                partialPaymentAllowed:row.partialPaymentAllowed, //
                                                allowedPayableAmount:row.allowedPayableAmount, //
                                                key: line.id, // keyTable+data?.vendorId+checkedData.data?.serviceAccount?.abonCode,
                                                selected:false, //
                                                child:true,
                                                id:row.id, //
                                                childInvoiceId:line.id,
                                                name: checkedData.data?.serviceAccount?.description, //
                                                idCode:  line.invoiceCode, // checkedData.data?.serviceAccount?.abonCode,
                                                scCode:checkedData.scCode, //  ? checkedData.data?.scCode,
                                                serviceCode: line.serviceCode, // row.serviceCode
                                                COMMAMOUNT: dataCom?.data?.commission, //
                                                amount: line.amount, //
                                                PMTID: line.invoiceCode, //
                                                date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-', //
                                                paymentTypeCode: data?.vendorId, //
                                                feeCalculationMethod:line.feeCalculationMethod, //
                                                serviceDesc:line.serviceDescription, //
                                                minAllowedAmount:row.minAllowedAmount, //
                                                maxAllowedAmount:row.maxAllowedAmount, //
                                                abonCode1:prefix+value, //
                                                abonCode2:additional, //
                                                identifSubType: selectedType, //
                                                vendorId: data?.vendorId, //
                                                fieldTitle:selectedField?.title, //
                                                transactionId:checkedData.data?.transactionId, //
                                                manualPaymentReceiverCode:line.paymentReceiverCode, // row.paymentReceiverCode
                                                category:category,
                                                invoiceId:row.id,
                                                paymentReceiverDescription:line.paymentReceiverDescription,
                                                time: 900,
                                            }
                                        )
                                        seaarchVendorId?.createRow?.push({
                                            id:row.id,
                                            childInvoiceId:line.id,
                                            partialPaymentAllowed:row.partialPaymentAllowed,
                                            invoiceType:row.invoiceType,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            name: checkedData.data?.serviceAccount?.description,
                                            idCode: checkedData.data?.serviceAccount?.abonCode,
                                            codeService: row.serviceCode,
                                            scCode:checkedData.data?.scCode,
                                            commission: dataCom?.data.commission,
                                            pmtAmount: row.currentDebt === 0 ? "" : row.currentDebt,
                                            PMTID: row.invoiceCode,
                                            date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                            paymentTypeCode: data?.vendorId,
                                            feeCalculationMethod:row.feeCalculationMethod,
                                            serviceDescription:row.serviceDescription,
                                            minAllowedAmount:row.minAllowedAmount,
                                            maxAllowedAmount:row.maxAllowedAmount,
                                            abonCode1:prefix+value,
                                            abonCode2:additional,
                                            identifSubType: selectedType,
                                            vendorId: data?.vendorId,
                                            fieldTitle:selectedField?.title,
                                            transactionId:checkedData.data?.transactionId,
                                            manualPmtReceiverCode:row.paymentReceiverCode,
                                            category:category,
                                            invoiceId:row.id,
                                            paymentReceiverDescription:row.paymentReceiverDescription,
                                        })
                                        temp_data[seaarchVendorIdIndex] = seaarchVendorId;
                                    }
                                }
                                setPaymentReceiver(row.paymentReceiverDescription)
                            }
                        }
                        else{
                            console.log(" line 897")
                            if(row.partialPaymentAllowed){
                                setIsEditable(true)
                            }else if(row.invoiceType ==='AVANS'){
                                setIsEditable(true)
                            }else if(row.invoiceType ==='GROUP' && row.allowedPayableAmount){
                                setIsEditable(true)
                            }else{
                                setIsEditable(false)
                            }

                            const feeCalcList = checkedData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===row.feeCalculationMethod)
                            const req = {
                                "feeCalculationMethod": row.feeCalculationMethod,
                                'amount': row.currentDebt,
                                "feePercent":  feeCalcList[0].feePercent ,
                                "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                                "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                            }

                            let dataCom;
                            dataCom = await calculateCommision(req, language)
                            setfeeCalculationMethod(row.feeCalculationMethod)
                            // setChildinvoice(false)
                            setServiceDesc(row.serviceDescription)
                            setServicecode(row.serviceCode)
                            setInvoiceId(row.invoiceId)
                            row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)

                            let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId);

                            if(seaarchVendorId === null || seaarchVendorId === undefined) {

                                seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId);
                            }
                            if(seaarchVendorId === null || seaarchVendorId === undefined) {
                                temp_data.push(...tableData,
                                    {
                                        paymentTitle: data.title,
                                        paymentTypeCode: data?.vendorId,
                                        paymentRow: [{
                                            feePercent:  feeCalcList[0].feePercent ,
                                            feeMinAmount: feeCalcList[0].feeMinAmount  ,
                                            feeMaxAmount:feeCalcList[0].feeMaxAmount  ,
                                            partialPaymentAllowed:row.partialPaymentAllowed,
                                            invoiceType:row.invoiceType,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            id:row.id,
                                            selected:false,
                                            scCode:checkedData.data?.scCode,
                                            key: keyTable+data?.vendorId+checkedData.data?.serviceAccount?.abonCode,
                                            name: checkedData.data?.serviceAccount?.description,
                                            idCode: checkedData.data?.serviceAccount?.abonCode,
                                            serviceCode: row.serviceCode,
                                            COMMAMOUNT: dataCom?.data?.commission,
                                            amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                            PMTID: row.invoiceCode,
                                            date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                            paymentTypeCode: data?.vendorId,
                                            feeCalculationMethod:row.feeCalculationMethod,
                                            serviceDesc:row.serviceDescription,
                                            minAllowedAmount:row.minAllowedAmount,
                                            maxAllowedAmount:row.maxAllowedAmount,
                                            abonCode1:prefix+value,
                                            abonCode2:additional,
                                            identifSubType: selectedType,
                                            vendorId: data?.vendorId,
                                            fieldTitle:selectedField?.title,
                                            transactionId:checkedData.data?.transactionId,
                                            manualPaymentReceiverCode:row.paymentReceiverCode,
                                            category:category,
                                            invoiceId:row.id,
                                            paymentReceiverDescription:row.paymentReceiverDescription,
                                            time: 900,
                                            abonName: checkedData.data?.serviceAccount?.description,
                                        }],
                                        createRow:[{
                                            partialPaymentAllowed:row.partialPaymentAllowed,
                                            id:row.id,
                                            invoiceType:row.invoiceType,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            scCode:checkedData.data?.scCode,
                                            key: keyTable+data?.vendorId+checkedData.data?.serviceAccount?.abonCode,
                                            name: checkedData.data?.serviceAccount?.description,
                                            idCode: checkedData.data?.serviceAccount?.abonCode,
                                            serviceCode: row.serviceCode,
                                            COMMAMOUNT:dataCom?.data?.commission,
                                            amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                            PMTID: row.invoiceCode,
                                            date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                            paymentTypeCode: data?.vendorId,
                                            feeCalculationMethod:row.feeCalculationMethod,
                                            serviceDesc:row.serviceDescription,
                                            minAllowedAmount:row.minAllowedAmount,
                                            maxAllowedAmount:row.maxAllowedAmount,
                                            abonCode1:prefix+value,
                                            abonCode2:additional,
                                            identifSubType: selectedType,
                                            vendorId: data?.vendorId,
                                            fieldTitle:selectedField?.title,
                                            transactionId:checkedData.data?.transactionId,
                                            manualPaymentReceiverCode:row.paymentReceiverCode,
                                            category:category,
                                            invoiceId:row.id,
                                            paymentReceiverDescription:row.paymentReceiverDescription,
                                            abonName: checkedData.data?.serviceAccount?.description,
                                        }]

                                    }
                                )

                            }
                            else {
                                let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId);
                                if(seaarchVendorIdIndex == -1) {
                                    seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId);
                                }
                                const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === row.id && item1.idCode === checkedData.data?.serviceAccount?.abonCode)
                                if(seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {


                                    keyTable = seaarchVendorId?.paymentRow?.length;
                                    temp_data = [...tableData]
                                    seaarchVendorId?.paymentRow?.push(
                                        {
                                            feePercent:  feeCalcList[0].feePercent ,
                                            feeMinAmount: feeCalcList[0].feeMinAmount  ,
                                            feeMaxAmount:feeCalcList[0].feeMaxAmount  ,
                                            partialPaymentAllowed:row.partialPaymentAllowed,
                                            invoiceType:row.invoiceType,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            id:row.id,
                                            selected:false,
                                            scCode:checkedData.data?.scCode,
                                            key: keyTable+data?.vendorId+checkedData.data?.serviceAccount?.abonCode,
                                            name: checkedData.data?.serviceAccount?.description,
                                            idCode: checkedData.data?.serviceAccount?.abonCode,
                                            serviceCode: row.serviceCode,
                                            COMMAMOUNT:dataCom?.data?.commission,
                                            amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                            PMTID: row.invoiceCode,
                                            date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                            paymentTypeCode: data?.vendorId,
                                            minAllowedAmount:row.minAllowedAmount,
                                            feeCalculationMethod:row.feeCalculationMethod,
                                            serviceDesc:row.serviceDescription,
                                            maxAllowedAmount:row.maxAllowedAmount,
                                            abonCode1:prefix+value,
                                            abonCode2:additional,
                                            identifSubType: selectedType,
                                            vendorId: data?.vendorId,
                                            fieldTitle:selectedField?.title,
                                            transactionId:checkedData.data?.transactionId,
                                            manualPaymentReceiverCode:row.paymentReceiverCode,
                                            category:category,
                                            invoiceId:row.id,
                                            paymentReceiverDescription:row.paymentReceiverDescription,
                                            time: 900,
                                            abonName: checkedData.data?.serviceAccount?.description,
                                        }
                                    )
                                    seaarchVendorId?.createRow?.push({
                                        id:row.id,
                                        partialPaymentAllowed:row.partialPaymentAllowed,
                                        invoiceType:row.invoiceType,
                                        allowedPayableAmount:row.allowedPayableAmount,
                                        scCode:checkedData.data?.scCode,
                                        key: keyTable+data?.vendorId+checkedData.data?.serviceAccount?.abonCode,
                                        name: checkedData.data?.serviceAccount?.description,
                                        idCode: checkedData.data?.serviceAccount?.abonCode,
                                        serviceCode: row.serviceCode,
                                        COMMAMOUNT: dataCom?.data?.commission,
                                        amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                        PMTID: row.invoiceCode,
                                        date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                        paymentTypeCode: data?.vendorId,
                                        feeCalculationMethod:row.feeCalculationMethod,
                                        serviceDesc:row.serviceDescription,
                                        minAllowedAmount:row.minAllowedAmount,
                                        maxAllowedAmount:row.maxAllowedAmount,
                                        abonCode1:prefix+value,
                                        abonCode2:additional,
                                        identifSubType: selectedType,
                                        vendorId: data?.vendorId,
                                        fieldTitle:selectedField?.title,
                                        transactionId:checkedData.data?.transactionId,
                                        manualPaymentReceiverCode:row.paymentReceiverCode,
                                        category:category,
                                        invoiceId:row.id,
                                        paymentReceiverDescription:row.paymentReceiverDescription,
                                        abonName: checkedData.data?.serviceAccount?.description,
                                    })
                                    temp_data[seaarchVendorIdIndex] = seaarchVendorId;


                                }

                            }
                            setPaymentReceiver(row.paymentReceiverDescription)
                        }

                    }
                }


                setTableVisible(true);
            }
            else if(checkedData.status?.description!== 'SERVICE_UNAVAILABLE' && checkedData.status?.description!== 'NOT_FOUND' && checkedData.status?.code !== 400 && checkedData.data?.transactionId !==null){
                const codeList:any = []
                code?.map((row)=>{
                    codeList.push({
                        code:row
                    })
                })
                let datanew
                    if(codeList.length!==0){
                        const formData={
                            "identificationSubtype":selectedType,
                            "code": prefix+value ,
                            "transactionId": checkedData.data?.transactionId,
                            "sourceId": 1,
                            "vendorId": data?.vendorId,
                            "additionalCode": additional,
                            "codeList":codeList
                        }
                        datanew = await gppclassificationCode(formData,language)
                    }
                    else{
                        datanew=checkedData
                    }
                let payment_data=[]
                if(datanew.status?.description!== 'SERVICE_UNAVAILABLE' && datanew.status?.description!== 'NOT_FOUND' && datanew.status?.code !== 400){
                    setClassificationData(datanew)


                    if(codeList.length===0){
                        setClassificationModal(true)

                    }else{
                        setClassificationModal(false)

                    }
                    if((datanew.data?.invoiceList?.length !==0 && datanew.data?.invoiceList !== null) || (datanew.data?.unUsedPrePaidServiceGroupList?.length !==0 && datanew.data?.unUsedPrePaidServiceGroupList !==null)){
                    if(datanew.data?.invoiceList?.length !==0 && datanew.data?.invoiceList !== null) {
                        for(var row1 in datanew.data?.invoiceList){
                            var row= datanew.data?.invoiceList[row1]

                                row.paymentReceivers?.map((item) => {
                                    payment_data.push({
                                        label: item.description,
                                        value: item.code
                                    })
                                })

                                if(row.partialPaymentAllowed){
                                    setIsEditable(true)
                                }else if(row.invoiceType ==='AVANS'){
                                    setIsEditable(true)
                                }else if(row.invoiceType ==='GROUP' && row.allowedPayableAmount){
                                    setIsEditable(true)
                                }else{
                                    setIsEditable(false)
                                }

                                setServiceDesc(row.serviceDescription)
                                setPaymentReceiver(row.paymentReceiverDescription)
                                setServicecode(row.serviceCode)
                                setInvoiceId(row.invoiceId)
                            const feeCalcList = checkedData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===row.feeCalculationMethod)
                            const req = {
                                "feeCalculationMethod": row.feeCalculationMethod,
                                'amount': row.currentDebt,
                                "feePercent":  feeCalcList[0].feePercent ,
                                "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                                "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                            }

                            let dataCom;
                            dataCom = await calculateCommision(req, language)
                                row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)
                                let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId);

                                if (seaarchVendorId === null || seaarchVendorId === undefined) {
                                    seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId);
                                }


                                if (seaarchVendorId === null || seaarchVendorId === undefined) {

                                    temp_data.push(...tableData,
                                        {
                                            paymentTitle: data.title,
                                            paymentTypeCode: data?.vendorId,
                                            partialPaymentAllowed:row.partialPaymentAllowed,
                                            paymentRow: [{
                                                feePercent:  feeCalcList[0].feePercent ,
                                                feeMinAmount: feeCalcList[0].feeMinAmount  ,
                                                feeMaxAmount:feeCalcList[0].feeMaxAmount  ,
                                                id:row.id,
                                                selected:false,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                scCode:checkedData.data?.scCode,
                                                key: keyTable + data?.vendorId + checkedData.data?.serviceAccount?.abonCode,
                                                name: checkedData.data?.serviceAccount?.description,
                                                idCode: checkedData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT: dataCom?.data?.commission,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod: row.feeCalculationMethod,
                                                serviceDesc: row.serviceDescription,
                                                maxAllowedAmount: row.maxAllowedAmount,
                                                minAllowedAmount: row.minAllowedAmount,
                                                abonCode1: prefix + value,
                                                abonCode2: additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle: selectedField?.title,
                                                transactionId: checkedData.data?.transactionId,
                                                manualPaymentReceiverCode: payment_data.length === 0 ? row.paymentReceiverCode : '',
                                                category: category,
                                                invoiceId: row.id ? row.id : null,
                                                paymentReceivers: payment_data,
                                                alert: false,
                                                paymentReceiverDescription: row.paymentReceiverDescription,
                                                time: 900,
                                                
                                            }],
                                        }
                                    )


                                }
                                else {

                                    let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId);

                                    if (seaarchVendorIdIndex == -1) {
                                        seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId);
                                    }

                                    const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === row.id && item1.idCode === checkedData.data?.serviceAccount?.abonCode)

                                    if (seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {
                                        keyTable = seaarchVendorId?.paymentRow?.length;

                                        temp_data = [...tableData]


                                        seaarchVendorId?.paymentRow?.push(
                                            {
                                                feePercent:  feeCalcList[0].feePercent ,
                                                feeMinAmount: feeCalcList[0].feeMinAmount  ,
                                                feeMaxAmount:feeCalcList[0].feeMaxAmount  ,
                                                id:row.id,
                                                selected:false,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                scCode:checkedData.scCode,
                                                key: keyTable + data?.vendorId + checkedData.data?.serviceAccount?.abonCode,
                                                name: checkedData.data?.serviceAccount?.description,
                                                idCode: checkedData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT: dataCom?.data?.commission,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod: row.feeCalculationMethod,
                                                minAllowedAmount: row.minAllowedAmount,
                                                maxAllowedAmount: row.maxAllowedAmount,
                                                serviceDesc: row.serviceDescription,
                                                abonCode1: prefix + value,
                                                abonCode2: additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle: selectedField?.title,
                                                transactionId: checkedData.data?.transactionId,
                                                manualPaymentReceiverCode: payment_data.length === 0 ? row.paymentReceiverCode : '',
                                                category: category,
                                                invoiceId: row.id ? row.id : null,
                                                paymentReceivers: payment_data,
                                                alert: false,
                                                paymentReceiverDescription: row.paymentReceiverDescription,
                                                time: 900,

                                            }
                                        )

                                        temp_data[seaarchVendorIdIndex] = seaarchVendorId;

                                    }

                                }

                            }


                        setTableVisible(true)
                    }
                    else{

                    }


                    }else{
                        setClassificationModal(false)
                        setMessageVisible(true)
                        setErrorMessage(t("transfers.gppClassError") + `${prefix+value}`)
                    }
                }else{
                    setClassificationModal(false)
                    setMessageVisible(true)
                    setErrorMessage(datanew.status?.message)
                }


            }
            else{

                setMessageVisible(true)
                setErrorMessage(checkedData.status?.message)
            }

        }
        else{
            if(checkData?.data?.invoiceList?.length>0 && checkData.status?.description!== 'SERVICE_UNAVAILABLE' && checkData.status?.code !== 400 && checkData.data?.transactionId !==null){
                // setChildinvoice(false)
                setClassificationModal(false);
                for(var row1 in checkData.data?.invoiceList){
                    var row = checkData.data?.invoiceList[row1]
                    if(row?.childInvoiceList !== null && row?.childInvoiceList !== undefined && row?.childInvoiceList?.length >0){
                        setChildinvoice(true)
                        for( var line1 in row?.childInvoiceList)
                           {
                               var line = row?.childInvoiceList[line1]
                               const feeCalcList = checkData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===line.feeCalculationMethod)
                               const req = {
                                   "feeCalculationMethod": line.feeCalculationMethod,
                                   'amount': line.amount,
                                   "feePercent":  feeCalcList[0].feePercent ,
                                   "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                                   "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                               }


                               const dataCom = await calculateCommision(req, language)
                                // row.allowedPayableAmount  ? setIsEditable(true) :setIsEditable(false)
                                setfeeCalculationMethod(row.feeCalculationMethod)
                                setServiceDesc(row.serviceDescription)
                                setServicecode(row.serviceCode)
                                setInvoiceId(row.invoiceId)
                                row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)

                                let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId);

                                if(seaarchVendorId === null || seaarchVendorId === undefined) {

                                    seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId);
                                }
                                if(seaarchVendorId === null || seaarchVendorId === undefined) {



                                    temp_data.push(...tableData,
                                        {
                                            paymentTitle: data.title,
                                            paymentTypeCode: data?.vendorId,
                                            allowedPayableAmount:row.allowedPayableAmount,
                                            child:true,
                                            paymentRow: [{
                                                feePercent:  feeCalcList[0].feePercent ,
                                                feeMinAmount: feeCalcList[0].feeMinAmount  ,
                                                feeMaxAmount:feeCalcList[0].feeMaxAmount  ,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                key: line.id,
                                                selected:false,
                                                child:true,
                                                id:row.id,
                                                childInvoiceId:line.id,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode:  line.invoiceCode,
                                                codeService: line.serviceCode,
                                                scCode:checkData.data?.scCode,
                                                commission: line.commission !== null ? line.commission : dataCom?.data?.commission,
                                                pmtAmount: line.amount,
                                                PMTID: line.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:line.feeCalculationMethod,
                                                serviceDescription:line.serviceDescription,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPmtReceiverCode:line.paymentReceiverCode,
                                                category:category,
                                                invoiceId:row.id,
                                                paymentReceiverDescription:line.paymentReceiverDescription,
                                                time: 900,
                                            }],
                                            createRow:[{
                                                key: line.id,
                                                id:row.id,
                                                childInvoiceId:line.id,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode: checkData.data?.serviceAccount?.abonCode,
                                                codeService: row.serviceCode,
                                                scCode:checkData.data?.scCode,
                                                commission: row.commission !== null ? row.commission : 0.0,
                                                pmtAmount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date:row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                serviceDescription:row.serviceDescription,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPmtReceiverCode:row.paymentReceiverCode,
                                                category:category,
                                                invoiceId:row.id,
                                                paymentReceiverDescription:row.paymentReceiverDescription,
                                            }],

                                        }
                                    )

                                } else {


                                    let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId);


                                    if(seaarchVendorIdIndex == -1) {


                                        seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId);
                                    }
                                    const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === line.id && item1.idCode ===  line.invoiceCode)

                                    if(seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {


                                        keyTable = seaarchVendorId?.paymentRow?.length;
                                        temp_data = [...tableData]
                                        seaarchVendorId?.paymentRow?.push(
                                            {
                                                feePercent: checkData.data?.feeCalculationList[0].feePercent,
                                                feeMinAmount: checkData.data?.feeCalculationList[0].feeMinAmount,
                                                feeMaxAmount: checkData.data?.feeCalculationList[0].feeMaxAmount,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                key: line.id,
                                                id:row.id,
                                                selected:false,
                                                child:true,
                                                childInvoiceId:line.id,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode:  line.invoiceCode,
                                                scCode:checkData.data?.scCode,
                                                codeService: line.serviceCode,
                                                commission: line.commission !== null ? line.commission : 0.0,
                                                pmtAmount: line.amount,
                                                PMTID: line.invoiceCode,
                                                date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:line.feeCalculationMethod,
                                                serviceDescription:line.serviceDescription,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPmtReceiverCode:line.paymentReceiverCode,
                                                category:category,
                                                invoiceId:row.id,
                                                paymentReceiverDescription:line.paymentReceiverDescription,
                                                time: 900,
                                            }
                                        )
                                        seaarchVendorId?.createRow?.push({
                                            key: line.id,
                                            id:row.id,
                                            childInvoiceId:line.id,
                                            name: checkData.data?.serviceAccount?.description,
                                            idCode: checkData.data?.serviceAccount?.abonCode,
                                            codeService: row.serviceCode,
                                            scCode:checkData.data?.scCode,
                                            commission: row.commission !== null ? row.commission : 0.0,
                                            pmtAmount: row.currentDebt === 0 ? "" : row.currentDebt,
                                            PMTID: row.invoiceCode,
                                            date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10) ).format('DD.MM.YYYY'):'-',
                                            paymentTypeCode: data?.vendorId,
                                            feeCalculationMethod:row.feeCalculationMethod,
                                            serviceDescription:row.serviceDescription,
                                            minAllowedAmount:row.minAllowedAmount,
                                            maxAllowedAmount:row.maxAllowedAmount,
                                            abonCode1:prefix+value,
                                            abonCode2:additional,
                                            identifSubType: selectedType,
                                            vendorId: data?.vendorId,
                                            fieldTitle:selectedField?.title,
                                            transactionId:checkData.data?.transactionId,
                                            manualPmtReceiverCode:row.paymentReceiverCode,
                                            category:category,
                                            invoiceId:row.id,
                                            paymentReceiverDescription:row.paymentReceiverDescription,


                                        })
                                        temp_data[seaarchVendorIdIndex] = seaarchVendorId;


                                    }

                                }
                                setPaymentReceiver(row.paymentReceiverDescription)
                            }

                    }
                    else
                    {
                        if(row.partialPaymentAllowed){
                            setIsEditable(true)
                        }else if(row.invoiceType ==='AVANS'){
                            setIsEditable(true)
                        }else if(row.invoiceType ==='GROUP' && row.allowedPayableAmount){
                            setIsEditable(true)
                        }else{
                            setIsEditable(false)
                        }
                        const feeCalcList = checkData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===row.feeCalculationMethod)
                        const req = {
                            "feeCalculationMethod": row.feeCalculationMethod,
                            'amount': row.currentDebt,
                            "feePercent":  feeCalcList[0].feePercent ,
                            "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                            "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                        }

                        let dataCom;
                        dataCom = await calculateCommision(req, language)
                        setfeeCalculationMethod(row.feeCalculationMethod)
                        setServiceDesc(row.serviceDescription)
                        setServicecode(row.serviceCode)
                        setInvoiceId(row.invoiceId)
                        row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)

                        let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId);

                        if (seaarchVendorId === null || seaarchVendorId === undefined) {
                            seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId);
                        }
                        if (seaarchVendorId === null || seaarchVendorId === undefined) {

                            temp_data.push(...tableData,
                                {
                                    paymentTitle: data.title,
                                    paymentTypeCode: data?.vendorId,
                                    paymentRow: [{
                                        feePercent: checkData.data?.feeCalculationList[0].feePercent,
                                        feeMinAmount: checkData.data?.feeCalculationList[0].feeMinAmount,
                                        feeMaxAmount: checkData.data?.feeCalculationList[0].feeMaxAmount,
                                        id: row.id,
                                        selected:false,
                                        partialPaymentAllowed:row.partialPaymentAllowed,
                                        invoiceType:row.invoiceType,
                                        allowedPayableAmount:row.allowedPayableAmount,
                                        scCode: checkData.data?.scCode,
                                        key: keyTable + data?.vendorId + checkData.data?.serviceAccount?.abonCode,
                                        name: checkData.data?.serviceAccount?.description,
                                        idCode: checkData.data?.serviceAccount?.abonCode,
                                        serviceCode: row.serviceCode,
                                        COMMAMOUNT: dataCom?.data?.commission,
                                        amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                        PMTID: row.invoiceCode,
                                        date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                        paymentTypeCode: data?.vendorId,
                                        feeCalculationMethod: row.feeCalculationMethod,
                                        serviceDesc: row.serviceDescription,
                                        minAllowedAmount: row.minAllowedAmount,
                                        maxAllowedAmount: row.maxAllowedAmount,
                                        abonCode1: prefix + value,
                                        abonCode2: additional,
                                        identifSubType: selectedType,
                                        vendorId: data?.vendorId,
                                        fieldTitle: selectedField?.title,
                                        transactionId: checkData.data?.transactionId,
                                        manualPaymentReceiverCode: row.paymentReceiverCode,
                                        category: category,
                                        invoiceId: row.id,
                                        paymentReceiverDescription: row.paymentReceiverDescription,
                                        time: 900,
                                    }],
                                    createRow: [{
                                        partialPaymentAllowed:row.partialPaymentAllowed,
                                        invoiceType:row.invoiceType,
                                        allowedPayableAmount:row.allowedPayableAmount,
                                        id: row.id,
                                        scCode: checkData.data?.scCode,
                                        key: keyTable + data?.vendorId + checkData.data?.serviceAccount?.abonCode,
                                        name: checkData.data?.serviceAccount?.description,
                                        idCode: checkData.data?.serviceAccount?.abonCode,
                                        serviceCode: row.serviceCode,
                                        COMMAMOUNT: dataCom?.data?.commission,
                                        amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                        PMTID: row.invoiceCode,
                                        date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                        paymentTypeCode: data?.vendorId,
                                        feeCalculationMethod: row.feeCalculationMethod,
                                        serviceDesc: row.serviceDescription,
                                        minAllowedAmount: row.minAllowedAmount,
                                        maxAllowedAmount: row.maxAllowedAmount,
                                        abonCode1: prefix + value,
                                        abonCode2: additional,
                                        identifSubType: selectedType,
                                        vendorId: data?.vendorId,
                                        fieldTitle: selectedField?.title,
                                        transactionId: checkData.data?.transactionId,
                                        manualPaymentReceiverCode: row.paymentReceiverCode,
                                        category: category,
                                        invoiceId: row.id,
                                        paymentReceiverDescription: row.paymentReceiverDescription
                                    }]
                                }
                            )

                        } else {

                            let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId);

                            if (seaarchVendorIdIndex == -1) {
                                seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId);
                            }

                            const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === row.id && item1.idCode === checkData.data?.serviceAccount?.abonCode)
                            if (seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {
                                keyTable = seaarchVendorId?.paymentRow?.length;
                                temp_data = [...tableData]
                                seaarchVendorId?.paymentRow?.push(
                                    {
                                        feePercent: checkData.data?.feeCalculationList[0].feePercent,
                                        feeMinAmount: checkData.data?.feeCalculationList[0].feeMinAmount,
                                        feeMaxAmount: checkData.data?.feeCalculationList[0].feeMaxAmount,
                                        id: row.id,
                                        selected:false,
                                        invoiceType:row.invoiceType,
                                        partialPaymentAllowed:row.partialPaymentAllowed,
                                        allowedPayableAmount:row.allowedPayableAmount,
                                        scCode: checkData.data?.scCode,
                                        key: keyTable + data?.vendorId + checkData.data?.serviceAccount?.abonCode,
                                        name: checkData.data?.serviceAccount?.description,
                                        idCode: checkData.data?.serviceAccount?.abonCode,
                                        serviceCode: row.serviceCode,
                                        COMMAMOUNT: dataCom?.data?.commission,
                                        amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                        PMTID: row.invoiceCode,
                                        date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                        paymentTypeCode: data?.vendorId,
                                        minAllowedAmount: row.minAllowedAmount,
                                        feeCalculationMethod: row.feeCalculationMethod,
                                        serviceDesc: row.serviceDescription,
                                        maxAllowedAmount: row.maxAllowedAmount,
                                        abonCode1: prefix + value,
                                        abonCode2: additional,
                                        identifSubType: selectedType,
                                        vendorId: data?.vendorId,
                                        fieldTitle: selectedField?.title,
                                        transactionId: checkData.data?.transactionId,
                                        manualPaymentReceiverCode: row.paymentReceiverCode,
                                        category: category,
                                        invoiceId: row.id,
                                        paymentReceiverDescription: row.paymentReceiverDescription,
                                        time: 900,
                                    }
                                )
                                seaarchVendorId?.createRow?.push(
                                    {
                                        id: row.id,
                                        invoiceType:row.invoiceType,
                                        partialPaymentAllowed:row.partialPaymentAllowed,
                                        allowedPayableAmount:row.allowedPayableAmount,
                                        scCode: checkData.data?.scCode,
                                        key: keyTable + data?.vendorId + checkData.data?.serviceAccount?.abonCode,
                                        name: checkData.data?.serviceAccount?.description,
                                        idCode: checkData.data?.serviceAccount?.abonCode,
                                        serviceCode: row.serviceCode,
                                        COMMAMOUNT: dataCom?.data?.commission,
                                        amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                        PMTID: row.invoiceCode,
                                        date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                        paymentTypeCode: data?.vendorId,
                                        minAllowedAmount: row.minAllowedAmount,
                                        feeCalculationMethod: row.feeCalculationMethod,
                                        serviceDesc: row.serviceDescription,
                                        maxAllowedAmount: row.maxAllowedAmount,
                                        abonCode1: prefix + value,
                                        abonCode2: additional,
                                        identifSubType: selectedType,
                                        vendorId: data?.vendorId,
                                        fieldTitle: selectedField?.title,
                                        transactionId: checkData.data?.transactionId,
                                        manualPaymentReceiverCode: row.paymentReceiverCode,
                                        category: category,
                                        invoiceId: row.id,
                                        paymentReceiverDescription: row.paymentReceiverDescription
                                    }
                                )

                                temp_data[seaarchVendorIdIndex] = seaarchVendorId;
                            }
                        }
                        setPaymentReceiver(row.paymentReceiverDescription)
                    }
                }

                setTableVisible(true);
            }
            else if(checkData.status?.description!== 'SERVICE_UNAVAILABLE' && checkData.status?.description!== 'NOT_FOUND' && checkData.status?.code !== 400 && checkData.data?.transactionId !==null){
                const codeList:any = []

                code?.map((row)=>{
                    codeList.push({
                        code:row
                    })
                })
                let datanew
                if(codeList.length!==0){
                    const formData={
                        "identificationSubtype":selectedType,
                        "code": prefix+value ,
                        "transactionId": checkData.data?.transactionId,
                        "sourceId": 1,
                        "vendorId": data?.vendorId,
                        "additionalCode": additional,
                        "codeList":codeList
                    }
                     datanew = await gppclassificationCode(formData,language)
                }
                else{
                    datanew=checkData
                }


                let payment_data=[]
                if(datanew.status?.description!== 'SERVICE_UNAVAILABLE' && datanew.status?.description!== 'NOT_FOUND' && datanew.status?.code !== 400){
                    setClassificationData(datanew)

                    if(codeList.length===0){
                        setClassificationModal(true)

                    }else{
                        setClassificationModal(false)

                    }
                    if((datanew.data?.invoiceList?.length !==0 && datanew.data?.invoiceList !== null) || (datanew.data?.unUsedPrePaidServiceGroupList?.length !==0 && datanew.data?.unUsedPrePaidServiceGroupList !==null) ){
                        if(datanew.data?.invoiceList?.length !==0 && datanew.data?.invoiceList !== null){
                            for(var row1 in datanew.data?.invoiceList){
                                var row= datanew.data?.invoiceList[row1]
                                row.paymentReceivers?.map((item)=>{
                                    payment_data.push({
                                        label:item.description,
                                        value:item.code
                                    })
                                })

                                if(row.partialPaymentAllowed){
                                    setIsEditable(true)
                                }else if(row.invoiceType ==='AVANS'){
                                    setIsEditable(true)
                                }else if(row.invoiceType ==='GROUP' && row.allowedPayableAmount){
                                    setIsEditable(true)
                                }else{
                                    setIsEditable(false)
                                }

                                setServiceDesc(row.serviceDescription)
                                setPaymentReceiver(row.paymentReceiverDescription)
                                setServicecode(row.serviceCode)
                                setInvoiceId(row.invoiceId)
                                const feeCalcList = checkData.data?.feeCalculationList.filter((item)=>item.feeCalculationMethod===row.feeCalculationMethod)
                                const req = {
                                    "feeCalculationMethod": row.feeCalculationMethod,
                                    'amount': row.currentDebt,
                                    "feePercent":  feeCalcList[0].feePercent ,
                                    "feeMinAmount": feeCalcList[0].feeMinAmount  ,
                                    "feeMaxAmount":feeCalcList[0].feeMaxAmount  ,
                                }

                                let dataCom;
                                dataCom = await calculateCommision(req, language)
                                row.maxAllowedAmount !== null ? setMaxAllowedAmount(row.maxAllowedAmount) : setMaxAllowedAmount(null)
                                let seaarchVendorId = tableData.find(element => element.paymentTypeCode === data?.vendorId);

                                if(seaarchVendorId === null || seaarchVendorId === undefined) {
                                    seaarchVendorId = temp_data.find(element => element.paymentTypeCode === data?.vendorId);
                                }


                                if(seaarchVendorId === null || seaarchVendorId === undefined) {

                                    temp_data.push(...tableData,
                                        {
                                            paymentTitle: data.title,
                                            paymentTypeCode: data?.vendorId,
                                            paymentRow: [{
                                                feePercent: checkData.data?.feeCalculationList[0].feePercent,
                                                feeMinAmount: checkData.data?.feeCalculationList[0].feeMinAmount,
                                                feeMaxAmount: checkData.data?.feeCalculationList[0].feeMaxAmount,
                                                id:row.id,
                                                selected:false,
                                                scCode:checkData.data?.scCode,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                key: keyTable+data?.vendorId+checkData.data?.serviceAccount?.abonCode,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode: checkData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT:  dataCom?.data?.commission,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date:  row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                serviceDesc:row.serviceDescription,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                minAllowedAmount:row.minAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPaymentReceiverCode:payment_data.length===0 ? row.paymentReceiverCode:'',
                                                category:category,
                                                invoiceId:row.id ? row.id:null,
                                                paymentReceivers:payment_data,
                                                alert:false,
                                                paymentReceiverDescription:row.paymentReceiverDescription,
                                                time: 900,
                                            }],
                                            createRow:[{
                                                id:row.id,
                                                scCode:checkData.data?.scCode,
                                                partialPaymentAllowed:row.partialPaymentAllowed,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                key: keyTable+data?.vendorId+checkData.data?.serviceAccount?.abonCode,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode: checkData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT:  dataCom?.data?.commission,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                serviceDesc:row.serviceDescription,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                minAllowedAmount:row.minAllowedAmount,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPaymentReceiverCode:payment_data.length===0 ? row.paymentReceiverCode:'',
                                                category:category,
                                                invoiceId:row.id ? row.id:null,
                                                paymentReceivers:payment_data,
                                                alert:false,
                                                paymentReceiverDescription:row.paymentReceiverDescription
                                            }]
                                        }
                                    )


                                } else {

                                    let seaarchVendorIdIndex = tableData.findIndex(element => element.paymentTypeCode === data?.vendorId);

                                    if(seaarchVendorIdIndex == -1) {
                                        seaarchVendorIdIndex = temp_data.findIndex(element => element.paymentTypeCode === data?.vendorId);
                                    }

                                    const newPaymentRow = seaarchVendorId?.paymentRow.filter((item1) => item1.id === row.id && item1.idCode === checkData.data?.serviceAccount?.abonCode)

                                    if(seaarchVendorIdIndex > -1 && newPaymentRow.length === 0) {
                                        keyTable = seaarchVendorId?.paymentRow?.length;

                                        temp_data = [...tableData]


                                        seaarchVendorId?.paymentRow?.push(
                                            {
                                                "feePercent": checkData.data?.feeCalculationList[0].feePercent,
                                                "feeMinAmount": checkData.data?.feeCalculationList[0].feeMinAmount,
                                                "feeMaxAmount": checkData.data?.feeCalculationList[0].feeMaxAmount,
                                                id:row.id,
                                                selected:false,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                scCode:checkData.data?.scCode,
                                                key: keyTable+data?.vendorId+checkData.data?.serviceAccount?.abonCode,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode: checkData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT:dataCom?.data?.commission ,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                serviceDesc:row.serviceDescription,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPaymentReceiverCode:payment_data.length===0 ? row.paymentReceiverCode:'',
                                                category:category,
                                                invoiceId:row.id ? row.id:null,
                                                paymentReceivers:payment_data,
                                                alert:false,
                                                paymentReceiverDescription:row.paymentReceiverDescription,
                                                time: 900,
                                            }
                                        )
                                        seaarchVendorId?.createRow?.push(
                                            {
                                                id:row.id,
                                                invoiceType:row.invoiceType,
                                                allowedPayableAmount:row.allowedPayableAmount,
                                                scCode:checkData.data?.scCode,
                                                key: keyTable+data?.vendorId+checkData.data?.serviceAccount?.abonCode,
                                                name: checkData.data?.serviceAccount?.description,
                                                idCode: checkData.data?.serviceAccount?.abonCode,
                                                serviceCode: row.serviceCode,
                                                COMMAMOUNT:dataCom?.data?.commission ,
                                                amount: row.currentDebt === 0 ? "" : row.currentDebt,
                                                PMTID: row.invoiceCode,
                                                date: row.invoiceDate !==null ? moment(row.invoiceDate.substring(0,10)).format('DD.MM.YYYY'):'-',
                                                paymentTypeCode: data?.vendorId,
                                                feeCalculationMethod:row.feeCalculationMethod,
                                                minAllowedAmount:row.minAllowedAmount,
                                                maxAllowedAmount:row.maxAllowedAmount,
                                                serviceDesc:row.serviceDescription,
                                                abonCode1:prefix+value,
                                                abonCode2:additional,
                                                identifSubType: selectedType,
                                                vendorId: data?.vendorId,
                                                fieldTitle:selectedField?.title,
                                                transactionId:checkData.data?.transactionId,
                                                manualPaymentReceiverCode:payment_data.length===0 ? row.paymentReceiverCode:'',
                                                category:category,
                                                invoiceId:row.id ? row.id:null,
                                                paymentReceivers:payment_data,
                                                alert:false,
                                                paymentReceiverDescription:row.paymentReceiverDescription

                                            }
                                        )
                                        temp_data[seaarchVendorIdIndex] = seaarchVendorId;

                                    }

                                }

                            }
                            setTableVisible(true)
                        }




                    }
                    else{
                        setClassificationModal(false)
                        setMessageVisible(true)
                        setErrorMessage(t("transfers.gppClassError") + `${prefix+value}`)
                    }
                }else{
                    setClassificationModal(false)
                    setMessageVisible(true)
                    setErrorMessage(datanew.status?.message)
                }


            }
            else{

                setMessageVisible(true)
                setErrorMessage(checkData.status?.message)
            }

        }


        if(temp_data?.length > 0) {
          let tempData = JSON.parse(JSON.stringify(temp_data));
            setTableData(tempData)
            setTableHeader(data.title)
        }

        setSearchLoad(false)
    }

    const nextButtonFunc =()=>{

        setMessageVisible(false)
        setErrorMessage('')

       let boolData=[]

        setSingleAlert('')
        tableData.map((line)=>{

           if(line.paymentRow.filter((item)=>(item.amount===""|| item.amount.toString().includes('-'))).length>0 || line.paymentRow.filter((item)=>item.manualPaymentReceiverCode==="")){
               boolData.push({
                  emptyAmountdata: line.paymentRow.filter((item)=>(item.amount==="") ),
                  paymentRec : line.paymentRow.filter((item)=>item.manualPaymentReceiverCode===""),
                  amountData:line.paymentRow.filter((item)=>item.amount.toString().includes('-')),
               })
           }
        })
          const dataPayment =boolData.filter((row)=>row.paymentRec.length!==0)
            const emptyAmountdata = boolData.filter((row)=>row.emptyAmountdata.length !==0)
        const amountData = boolData.filter((row)=>row.amountData.length !==0)

            if(boolData.length===0){
                setNextModalVisible(true)

            }
            else if (dataPayment!==undefined && dataPayment.length !== 0  ){

               if(dataPayment[0]?.paymentRec.length!==0) {
                    onExpandFunc(true, dataPayment[0].paymentRec[0])
                    setSingleAlert('dangerheader')
                }

            }
            else if(emptyAmountdata.length === 0 && amountData.length ===0 ){
                setNextModalVisible(true)
                setSingleAlert('')
            }
            else if(amountData.length !==0 || emptyAmountdata.length !== 0){

            setLoading(true)
                if(amountData.length !==0){

                    setErrorMessage(`Ödənilə biləcək minimal məbləğ ${amountData[0].amountData[0].minAllowedAmount}AZN`)

                }else if(emptyAmountdata.length !== 0){

                    setErrorMessage(`Ödənilə biləcək minimal məbləğ ${emptyAmountdata[0].emptyAmountdata[0].minAllowedAmount}AZN`)
                }
                setTableData(tableData)
                setMessageVisible(true)
                window.scrollTo({top:0})
            }

        setTimeout(() => {
            setLoading(false)
        }, 50);


    }

    const onTableTitle =(headerName, record)=>(
        <>
            <div className={'flex justify_between align_center'}>
                <span>{headerName}</span>
                <Button onClick={() => onClearAll(record)} style={{border:"none",boxShadow:"none",backgroundColor:'transparent',color:'red'}} >
                    <a><ClearIco/> {t("transfers.deleteAll")}</a>
                </Button>
            </div>
        </>
    )

    const pulldata =(data)=>{
        onSearch(formData,data, "additional")
    }

    const groupBy = (array, key) => {
        return array.reduce((result, currentItem) => {
            // Get the value of the key
            const groupKey = currentItem[key];

            // If the group doesn't exist, create it
            if (!result[groupKey]) {
                result[groupKey] = [];
            }

            // Add the current item to the group
            result[groupKey].push(currentItem);

            return result;
        }, {});
    };

    const newTransfer=() =>{
        setClear(true)
        setErrorMessage('')
        setVisible(true)
        setPrefix('')
        form.resetFields(['prefix','VALUE','VALUE2'
        ])
            }

  const moneyTransfer = () =>{
    let temp_data:any = []
    let temp_data2:any = []
    let commission=0
    let childList:any = []
    let codeService:any= []
    let descService:any=''
    let amount = 0
    console.log(tableData);
        tableData.map((payment)=>{
            console.log("payment")
            console.log(payment)

            if(payment.child !== undefined){
                console.log("line 2120")
                temp_data2 = groupBy(payment.paymentRow, 'abonCode1');
                console.log("temp_data2")
                console.log(temp_data2)
                Object.keys(temp_data2).map((key) => (
                    childList = [],
                    commission = 0,
                    amount = 0,
                    payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key).map((row,index) => {
                        console.log(row)
                        amount += row.amount
                        commission += row.COMMAMOUNT
                        childList.push({
                            "childInvoiceId": row.childInvoiceId,
                            "feeCalculationMethod": row.feeCalculationMethod,
                            "pmtAmount": row.amount,
                            "codeService": row.serviceCode,
                            "serviceDescription": row.serviceDesc,
                            "manualPmtReceiverCode": row.manualPaymentReceiverCode,
                            "paymentReceiverDescription": row.paymentReceiverDescription,
                            "commission": row.COMMAMOUNT
                        })
                        if(index !== payment.paymentRow.length-1) {
                            codeService += row.serviceCode + ','
                            descService+=row.serviceDesc  + ','
                        }
                        else{
                            codeService += row.serviceCode
                            descService+=row.serviceDesc
                        }
                        return {amount, commission, childList}
                    }),
                    temp_data.push({
                        "trnRequestType": "SAVE",
                        "PMTID": "1629245GP231226003",
                        "PMTCUSTID": documentNo,
                        "transactionId": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].transactionId,
                        "invoiceId": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].invoiceId,
                        "CUSTACC": accountValue,
                        "partialPaymentAllowed": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].partialPaymentAllowed,
                        "invoiceType": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].invoiceType,
                        "allowedPayableAmount": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].allowedPayableAmount,
                        "CUSTACCFORCOM": accountValue,
                        "category": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].category,
                        "vendorId": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].paymentTypeCode,
                        "manualPmtReceiverCode": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].manualPmtReceiverCode,
                        "paymentReceiverDescription": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].paymentReceiverDescription,
                        "orgName": "",
                        "orgAcc": "",
                        "orgTaxId": "",
                        "orgBankCode": "",
                        "orgBankName": "",
                        "fieldTitle": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].fieldTitle,
                        "identifSubType": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].identifSubType,
                        "abonCode1": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].abonCode1,
                        "abonCode2": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].abonCode2,

                    
                        "abonName": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0]?.abonName
                                  || payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0]?.name
                                  || "",

                        "serviceCode":codeService,
                        "serviceDesc": descService,
                        "pmtAmount": amount,
                        "CommCode": '',
                        "feeCalcMethod": payment.paymentRow?.filter(filterItem => filterItem.abonCode1 === key)[0].feeCalculationMethod,
                        "commission": financial(commission),
                        "PMTDET": "gpp",
                        "childInvoiceList": childList
                    })
                ));
            }
            else {
                payment.paymentRow?.map((row)=>{
                        return
                        amount += row.amount
                        commission += row.COMMAMOUNT
                })
                payment.paymentRow.map((row)=>{
                    console.log("line 2186")
                    console.log(row)
                        temp_data.push({
                            "trnRequestType": "SAVE",
                            "PMTID": "1629245GP231226003",
                            "PMTCUSTID": documentNo,
                            "transactionId": row.transactionId,
                            "invoiceId": row.invoiceId,
                            "CUSTACC": accountValue,
                            "CUSTACCFORCOM": accountValue,
                            "category": row.category,
                            "vendorId": row.paymentTypeCode,
                            "partialPaymentAllowed": row.partialPaymentAllowed,
                            "invoiceType": row.invoiceType,
                            "allowedPayableAmount": row.allowedPayableAmount,
                            "manualPaymentReceiverCode": row.manualPaymentReceiverCode,
                            "paymentReceiverDescription": row.paymentReceiverDescription,
                            "orgName": "",
                            "orgAcc": "",
                            "orgTaxId": "",
                            "orgBankCode": "",
                            "orgBankName": "",
                            "fieldTitle": row.fieldTitle,
                            "identifSubType": row.identifSubType,
                            "abonCode1": row.abonCode1,
                            "abonCode2": row.abonCode2,


                            "abonName": row?.abonName || row?.name || "",

                            "serviceCode": row.serviceCode,
                            "serviceDesc": row.serviceDesc,
                            "pmtAmount": row.amount,
                            "CommCode": '',
                            "feeCalcMethod": row.feeCalculationMethod,
                            "commission": row.COMMAMOUNT,
                            "PMTDET": "gpp"
                        })

                })
            }
        })
    const data =  moneyTransferGpp({"gppList":temp_data},language)
    return data;
}


    const onChange = (e) =>{
        setValue(e.target.value)
    }

    const onChangeAdd = (e) =>{
        setAdditional(e.target.value)
    }

    const handleInputChangeSave = async (row: any) => {
        setMessageVisible(false)
        setErrorMessage('')
        let temp_data = JSON.parse(JSON.stringify(tableData));
       if( (row.maxAllowedAmount === null || Number(row.amount) <= row.maxAllowedAmount) && !row.child ) {
           if( row.minAllowedAmount ===null ||  Number(row.amount)>=row.minAllowedAmount){



               const newData = tableData.find((item) => item.paymentTypeCode === row.paymentTypeCode);

               if (newData !== null && newData != undefined) {
                   const newPaymentRow = newData?.paymentRow.filter((item1) => item1.key === row.key)
                   const indexNew = newData?.paymentRow.findIndex((item) => item.key === row.key)


                   const index = tableData.findIndex((item) => item.paymentTypeCode === row.paymentTypeCode);
                   if (newPaymentRow?.length > 0) {

                       temp_data[index].paymentRow[indexNew] = row;

                       const req = {
                           "feeCalculationMethod": row.feeCalculationMethod,
                           'amount': row.amount,
                           "feePercent": row.feePercent,
                           "feeMinAmount": row.feeMinAmount,
                           "feeMaxAmount": row.feeMaxAmount,
                       }
                       //


                       const data = await calculateCommision(req, language)

                       temp_data[index].paymentRow[indexNew].COMMAMOUNT = data.data?.commission

                   } else {
                       temp_data = tableData.filter((item) => item.paymentTypeCode === row.paymentTypeCode);
                   }


               }

           }
            else{
                setLoading(true)

               window.scrollTo({top:0})
               setErrorMessage(`${t('notification.minAmountError')} ${row.minAllowedAmount}AZN`)
               setMessageVisible(true)

           }


       }
       else{
           setLoading(true)
           window.scrollTo({top:0})
           setErrorMessage(`${t("notification.maxAmountError")} ${row.maxAllowedAmount}AZN`)
           setMessageVisible(true)
       }
        setLoading(false)
        setTableData(temp_data)

    }

    const handleChildAmountChange =async (e:any,line:any, name: any)=>{
        setIsActive(false)
        let temp_data = JSON.parse(JSON.stringify(tableData));
        form.setFieldsValue({
            [name] : financial(e.target.value)
        })
        if(line.allowedPayableAmount){
            const formData= {
                "scCode": Number(line.paymentRow[0].scCode),
                "identificationSubtype": line.paymentRow[0].identifSubType,
                "code": line.paymentRow[0].abonCode1,
                "additionalCode": line.paymentRow[0].abonCode2,
                "transactionId": line.paymentRow[0].transactionId,
                "id": line.paymentRow[0].id,
                "partialPaymentAmount":Number(e.target.value)

            }

            const partialPaymentAmount = await partialPayment(formData,language)
            const newData = tableData.find((item) => item.paymentTypeCode === line.paymentTypeCode);
            const index = tableData.findIndex((item) => item.paymentTypeCode === line.paymentTypeCode);
            line.createRow.map(async (row) => {
                partialPaymentAmount?.data?.invoice?.childInvoiceList.map((item) => {
                    const indexNew = newData?.paymentRow.findIndex((items) => items.serviceCode === item.serviceCode)
                    temp_data[index].createRow[indexNew].codeService = item.serviceCode
                    temp_data[index].createRow[indexNew].feeCalculationMethod = item.feeCalculationMethod
                    temp_data[index].createRow[indexNew].serviceDescription = item.serviceDescription
                    temp_data[index].createRow[indexNew].pmtAmount = item.amount
                    temp_data[index].paymentRow[indexNew].amount = item.amount
                })
            })
            temp_data[index].createRow.map(async (row) => {
                const indexNew = newData?.createRow.findIndex((items) => items.childInvoiceId === row.childInvoiceId)
                const req = {
                    "feeCalculationMethod": row.feeCalculationMethod,
                    'amount': row.pmtAmount,
                    "feePercent":  temp_data[index].paymentRow[indexNew].feePercent,
                    "feeMinAmount": temp_data[index].paymentRow[indexNew].feeMinAmount,
                    "feeMaxAmount": temp_data[index].paymentRow[indexNew].feeMaxAmount,
                }
                const data = await calculateCommision(req, language)
                temp_data[index].createRow[indexNew].commission = data?.data?.commission
                temp_data[index].paymentRow[indexNew].COMMAMOUNT = data?.data?.commission
                if(indexNew === (temp_data[index].createRow.length - 1)) {
                    setTableData(temp_data)
                    setTimeout(()=>{
                        setIsActive(true)
                    },500)
                }
            })
        } else {
            setIsActive(true)
        }
    }

    const handleInputChange = (e: any, dataIndex: string) => {

        // setCopiedData(e.target.value)
    }

    const footerDeleteModal= ()=>(
        <>
                <div className={"flex justify_center align_center"}>
                    <Button
                        style={
                            {
                                width: 132,
                                padding: 20,
                                bottom:21
                            }
                        }
                        onClick={()=>{setModalvisible(false)}}  type={'button'} className={'light-button  refresh_btn next_modal_cancel_btn btn flex align_center justify_center'}>
                        Xeyr
                    </Button>
                    <Button
                        style={
                            {
                                width: 132,
                                padding: 0,
                                height: 41,
                                bottom:21
                            }
                        }
                        onClick={()=>handleDelete(key, deleteVendorKey)} className={"button blue-button"}>
                        Bəli
                    </Button>
                </div>
        </>
    )
    const footerDeleteModalALL= ()=>(
        <>
            <div className={"flex justify_center align_center"}>
                <Button style={
                    {
                        width: 132,
                        padding: 20,
                        bottom:21
                    }
                } onClick={()=>{setAllCleanModal(false)}}   type={'button'} className={'light-button  refresh_btn next_modal_cancel_btn btn flex align_center justify_center'}>
                    Xeyr
                </Button>
                <Button
                    style={
                    {
                        width: 132,
                        padding: 0,
                        height: 41,
                        bottom:21
                    }
                    }
                    onClick={()=>handleDeleteAll(deleteVendorKey)} className={"button blue-button"}>
                    Bəli
                </Button>
            </div>
        </>
    )
    const onExpandFunc = (expanded: boolean, record: any) => {
        const keys = [];
        if (!record.isExpandable) {
            if (expanded) {
                keys.push(record.key);
                setAccountKey(record.key);
            } else {
                setAccountKey("")
            }
             setActiveExpRow(keys);
        }
    }

    return (
        <Col className={''} span={24} style={{minWidth: "750px",minHeight:'750px'}}>
            <p className={'gpp_transfer'}>{t("transfers.creatingTransfer")}</p>

            <Col className={`gpp_fromacc gpp_transferselect gppheader ${fromBranch === null ? 'dangerheader' :''}`} span={12} style={{marginLeft:30,marginTop:20 }}>
                <SelectField
                    labelItem={t("transfers.fromAccount")}
                    placeholder={t("accountStatement.chooseAccount")}
                    options={fromSelectOptions}
                    name={'CUSTACC'}
                    required={true}
                    onChange={getSelectedFromBranch}
                />
                {/*{*/}
                {/*    timerMessage &&*/}
                {/*   <p><Text type={'danger'}>{t("transfers.gppInfo")}</Text></p>*/}
                {/*}*/}
                {
                    messageVisible &&
                    <Text type={'danger'}>{errorMessage}</Text>
                }
            </Col>

            <Form
                onSubmit={(e) => e.preventDefault(e)}
                form={form}

            >

            {

               transferData.length !==0 ? transferData?.map((item)=>{

                    return (
                      <Col span={24} className={'flex justify_between align_center ant-form-item '} style={{margin:'30px 30px 20px 30px'}}>
                        <Col span={7} className={'transfergpp'} style={{marginRight:10}}>
                            <div className={'flex align_center transfergpp_name'}>
                                {item?.data.icon}
                                <p style={{marginLeft:10}}>{item?.data.title}</p>
                            </div>
                        </Col>
                        <Col span={17} className={'transfergpp flex align_center'}>

                            <Col  className={'ant-form-item'}>
                                <SelectField
                                    options={fields}
                                    labelItem={t('transfers.paymenttype')}
                                    name={'paymentType'}
                                    value={selectedType}
                                    defaultValue={selectedField}
                                    defaultActiveFirstOption={true}
                                    // placeholder={fields[0].label}
                                    onChange={getSelectedType}
                                />
                            </Col>

                            <Col className={'ant-form-item'}>

                                <InputField
                                    name={'VALUE'}
                                    addonBefore={phone ? selectBefore :false}
                                    // value={value}
                                    somesymbolsOnly
                                    placeholder={placeholder1}
                                    disabled={selectedType===null}
                                    onKeyUp={onChange}
                                    form={form}
                                />
                            </Col>
                            {
                                selectedField?.options?.length >0 ?
                                   <Col className={'ant-form-item'}>
                                       <InputField
                                           name={'VALUE2'}
                                           // value={value}
                                           placeholder={placeholder2}
                                           disabled={selectedType===null}
                                           onKeyUp={onChangeAdd}
                                           form={form}
                                       />
                                   </Col> :''
                            }
                            <Col  className={'ant-form-item'} style={{textAlign:'end'}}>
                                <Button
                                    htmlType="submit"
                                    style={{width:"auto"}}
                                    loading={searchLoad}
                                    onClick={()=>onSearch(item.data, null, "main")}
                                    type={'primary'}>{t('transfers.search')}</Button>
                            </Col>
                        </Col>
                    </Col>
                    )
                }):
                   <Col span={24} className={'flex justify_between align_center ant-form-item '} style={{margin:'30px 30px 20px 30px'}}>
                   <Col span={7} className={'transfergpp'} style={{marginRight:10}}>
                       <div className={'flex align_center transfergpp_name'}>
                           <img
                                src={props.selectedTransfer?.icon}
                                alt={props.selectedTransfer?.title || 'icon'}
                                style={{ width: 24, height: 24, objectFit: 'contain',margin:"0" }}
                            />
                           <p style={{marginLeft:10}}>{props.selectedTransfer?.title}</p>
                       </div>
                   </Col>
                   <Col span={17} className={'transfergpp flex align_center'}>

                      <Col  className={'ant-form-item'}>

                          <SelectField
                              labelItem={t('transfers.paymenttype')}
                              options={fields}
                              name={'paymentType'}
                              value={selectedType}
                              onChange={getSelectedType}
                              defaultValue={selectedField}
                              defaultActiveFirstOption={true}
                              // placeholder={fields[0].label}

                          />
                      </Col>
                       <Col className={'ant-form-item'}>
                           <InputField
                               name={'VALUE'}
                               addonBefore={phone ? selectBefore : false}
                               // value={value}
                               placeholder={placeholder1}
                               somesymbolsOnly
                               disabled={selectedType===null}
                               onKeyUp={onChange}
                               form={form}
                           />
                       </Col>
                       {
                           selectedField?.options?.length >0 ?
                               <Col className={'ant-form-item'}>

                                   <InputField
                                       name={'VALUE2'}
                                       // value={value}
                                       placeholder={placeholder2}
                                       disabled={selectedType===null}
                                       onKeyUp={onChangeAdd}
                                       form={form}
                                   />
                               </Col> :''
                       }


                       <Col  className={'ant-form-item'} style={{textAlign:'end'}}>
                           <Button
                               htmlType="submit"
                               style={{width:"auto"}}
                               onClick={()=>{onSearch(props.selectedTransfer, null, "main");}}
                               type={'primary'}
                               loading={searchLoad}

                           >{t('transfers.search')}</Button>
                       </Col>
                   </Col>
               </Col>
            }
            { tableVisible && !loading &&
                <Col>
                    {
                        tableData.map((line:any,index:number) => {
                            return (<TableComponent
                            className={`odd-even-table gpptransfer_table `}
                            style={{margin:'30px 30px 20px 30px'}}
                            // rowClassName={`${line.paymentRow.filter((item)=>item.key === single_alert).length>0 ? "danger" : ''}`}
                            columns={columns}
                            pagination={false}
                            data={line.paymentRow}
                            handleInputChangeSave={handleInputChangeSave}
                            handleInputChange={(e: any, dataIndex: string) =>
                               handleInputChange(e, dataIndex)
                            }
                            summary={()=> {
                                let amount=0
                                let commission =0
                                if(line.child !== undefined ) {
                                   line.paymentRow.map((row:any)=>{
                                       amount += row.amount
                                       commission += row.COMMAMOUNT
                                   })
                                console.log(amount)
                                return ( <Table.Summary >
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}/>
                                        <Table.Summary.Cell index={2}/>
                                        <Table.Summary.Cell index={3}/>
                                        <Table.Summary.Cell index={4}/>
                                        <Table.Summary.Cell index={5}>
                                            <InputField
                                                defaultValue={financial(amount)}
                                                name={line.abonCode1}
                                                value={financial(amount)}
                                                disabled={!line.allowedPayableAmount}
                                                // onClick={()=>setIsActive(true)}
                                                onBlur={(e:any)=>handleChildAmountChange(e,line)}
                                                style={{width:125,textAlign:'end'}}
                                                prefix={<EditIco/>}
                                                form={form}
                                            />
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell  className={'com-amount-child'} index={6}>
                                            { !isActive ? <Spin  indicator={<SpinnerIco />}/> : financial(commission)}
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7}/>
                                        <Table.Summary.Cell index={8}/>
                                    </Table.Summary.Row>
                                </Table.Summary>
                                )}
                            }}
                            title={()=>onTableTitle(line.paymentTitle, line)}
                            expandable={{
                                        expandIconColumnIndex: 9,
                                        showExpandColumn: true,
                                        expandedRowKeys: activeExpRow,
                                        onExpand:onExpandFunc,
                                        expandedRowRender: (record:any) => (
                                            <div  className={`inner--table `}>
                                                <Row style={{height:"auto", alignItems: 'center',justifyContent:'space-between'}}>

                                                    <Col className={single_alert} style={{height:"auto",width:280,display:'flex',marginTop:15,marginLeft:20,marginBottom:10}}>
                                                        <Select
                                                            style={{height:40}}
                                                            onChange={(e)=>getPaymentReceiver(e,record.paymentReceivers,record)}
                                                            onMouseLeave={() => setHover(true)}
                                                            onMouseEnter={() => setHover(false)}
                                                            dropdownClassName={`${noHover  ? "" : "hoverable "} `}
                                                            disabled={record.paymentReceivers === null || record.paymentReceivers === undefined ||  record.paymentReceivers.length === 0 }
                                                            // value={record.pay}
                                                            placeholder={record.paymentReceivers !== null && record.paymentReceivers !== undefined && record.paymentReceivers.length !== 0  ?t("transfers.select")  : record.paymentReceiverDescription}
                                                            options={record.paymentReceivers}
                                                            // defaultValue={record.paymentReceivers !== null && record.paymentReceivers !== undefined && record.paymentReceivers.length !== 0  ? t("transfers.select") : record.paymentReceiverDescription}
                                                            className={'ServiceType'}

                                                        />

                                                    </Col>
                                                    <Button
                                                    type={'primary'}
                                                    onClick={()=>onMore(record)}
                                                    disabled={true}
                                                    className={'blue-button next_btn btn flex align_center justify_center'}
                                                    style={{marginRight:18}}
                                                    >
                                                        {t("ads.more")}
                                                </Button>
                                                </Row>

                                            </div>
                                        ),
                                        expandIcon: ({ expanded, onExpand, record }) =>
                                            expanded ? (
                                                <div>
                                                <Button
                                                    // className={` rotating-icon ${isRotated ? 'rotate' : 'rotate'}`}
                                                    style={{ marginLeft: 3 }}
                                                    icon={<ArrowUpIco />}
                                                    className="transfers-arrow-down gpp-arrow-hover transparent"
                                                    onClick={(e) => {onExpand(record, e); }}
                                                />
                                                </div>
                                            ) : (
                                                <div>
                                                <Button
                                                    // className={` rotating-iconic ${isRotated ? 'rotated' : 'rotated'}`}
                                                    style={{ marginLeft: 3 }}
                                                    icon={<ArrowDownIco />}
                                                    className="transfers-arrow-down gpp-arrow-hover transparent"
                                                    onClick={(e) => onExpand(record, e)}
                                                />
                                                </div>
                                            ),
                                    }}

                        />)
                        })
                    }
                </Col>
            }


            <Col className={'flex gpptransfer_footer justify_between align_center'}>
                <Button
                    type={'primary'}
                    ghost
                    style={{margin:'0 30px',width:"auto"}}
                    onClick={() => {
                        // props.selectedValue('',true,'')
                        setVisible(true)

                    }}
                >
                    {t('templates.back')}
                </Button>
                <Col className={'transfer_gpp'}>
                    <Button
                        type={'primary'}
                        style={{margin:'0 10px',width:"auto"}}
                        onClick={newTransfer}
                    >
                        {t("transfers.addNewTransfer")}
                    </Button>

                    <Button
                        disabled={!isActive || (fromBranch === null || tableData.length === 0) }
                        type={'primary'}
                        onClick={nextButtonFunc} style={{width: "auto", margin: '0 20px 0 0'}}
                    >
                        {OWNACCOUNT.NEXT}

                    </Button>
                </Col>

            </Col>

                {
                    nextModalvisible &&

                    <NextModalGpp
                        data={tableData}
                        visible={nextModalvisible}
                        value={fromBranch}
                        balance={fromBranch.BALANCE}
                        callBackApi={moneyTransfer}
                        onOktransfer={(e,bool,value) => {
                            props.selectedValue(e,bool,value)
                            // setTableData([])
                            // setVisible(true)
                        }}
                        onClose={()=>setNextModalVisible(false)}
                    />
                }
                {
                    visible &&
                    <GppModal
                        selectedValue={pullData}
                        visible={visible}
                        clear={clearRow}
                        modalTitle={t('newTransfer.organizations')}
                        onCancel={()=>setVisible(false)}
                        // placeholder={"Təşkilat üzrə axtarış"}
                    />
                }
                {
                    modalVisible &&
                    <Modal
                        open={modalVisible}
                        title={'Diqqət!'}
                        onOk={()=>handleDelete(key, deleteVendorKey)}
                        onCancel={()=>{setModalvisible(false)}}
                        footer={footerDeleteModal()}
                        closeIcon={<ModalCloseIco />}
                        style={{fontSize:18,textAlign:"center",fontWeight:500}}
                        // width={450}
                        className={'deleteRow'}
                    >
                        Sətir silinəcək. Əminsinizmi?
                    </Modal>
                }
                {
                    allCleanModal &&
                    <Modal
                        open={allCleanModal}
                        title={'Diqqət!'}
                        onOk={()=>handleDeleteAll(deleteVendorKey)}
                        onCancel={()=>{setAllCleanModal(false)}}
                        footer={footerDeleteModalALL()}
                        // width={450}
                        closeIcon={<ModalCloseIco />}
                        style={{fontSize:18,textAlign:"center",fontWeight:500}}
                        className={'deleteAll'}
                    >
                        Bütün sətirlər silinəcək. Əminsinizmi?
                    </Modal>
                }
                {
                    classificationModal &&
                    <ClassificationModal
                        transferType={classTitle}
                        selectedList={(e)=>{pulldata(e)}}
                        visible={classificationModal}
                        data={classificationData}
                        onClose={()=>setClassificationModal(false)}
                    />
                }
                {
                    moreVisible &&
                    <MoreModal
                        onClose={()=>setMoreModal(false)}
                        visible={moreVisible}
                        modalData={moreData}
                    />
                }
            </Form>
            {
                loading ? <FullScreenLoading /> : <></>
            }
        </Col>
    )
}

export default GppTransfer